import { render, staticRenderFns } from "./BackofficeRoot.vue?vue&type=template&id=2df86fdc"
import script from "./BackofficeRoot.vue?vue&type=script&lang=js"
export * from "./BackofficeRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports